import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, Row, Col, InputGroup, InputGroupText, Alert } from 'reactstrap';
import { toast } from 'react-toastify';
import { handleAddModifyOperation } from '../../../../Api/ApiMethods';

const RulingDataModal = ({
    apiEndpoint,
    isOpen,
    toggle,
    mode,
    selectedRuling,
    refreshData,
    arbitrationId
}) => {
    const [rulingData, setRulingData] = useState({
        arbitration: [],
        expertWitnessReportInformation: [],
        arrivalDate: '',
        rulingNumber: '',
        rulingResult: '',
        rulingType: '',
        appraisalFeeStatus: '',
        acceptedAppraisalFee: '',
        powerOfAttorneyFee: '',
        actionForRuling: '',
        objectionFee: '',
        objectionCaseNumber: '',
        objectingParty: '',
        opposingPowerOfAttorneyFee: '',
        willPayCounterPowerOfAttorneyFee: false,
        cpFullName: '',
        cpIban: '',
        cpBank: '',
        cpEmail: '',
        comments: ''
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});

    useEffect(() => {
        if (isOpen) {
            if (mode === 'add') {
                setRulingData({
                    arbitration: [arbitrationId], // arbitrationId'yi array olarak set et
                    expertWitnessReportInformation: [],
                    arrivalDate: '',
                    rulingNumber: '',
                    rulingResult: '',
                    rulingType: '',
                    appraisalFeeStatus: '',
                    acceptedAppraisalFee: '',
                    powerOfAttorneyFee: '',
                    actionForRuling: '',
                    objectionFee: '',
                    objectionCaseNumber: '',
                    objectingParty: '',
                    opposingPowerOfAttorneyFee: '',
                    willPayCounterPowerOfAttorneyFee: false,
                    cpFullName: '',
                    cpIban: '',
                    cpBank: '',
                    cpEmail: '',
                    comments: ''
                });
            } else if (mode === 'modify' && selectedRuling) {
                // API'den gelen veri formatını forma uygun hale getir
                const commentText = selectedRuling.comments && Array.isArray(selectedRuling.comments) && selectedRuling.comments.length > 0
                    ? selectedRuling.comments[0].comment || ''
                    : '';

                setRulingData({
                    id: selectedRuling.id,
                    arbitration: selectedRuling.arbitration || [arbitrationId],
                    expertWitnessReportInformation: selectedRuling.expertWitnessReportInformation || [],
                    arrivalDate: selectedRuling.arrivalDate ? selectedRuling.arrivalDate.split('T')[0] : '',
                    rulingNumber: selectedRuling.rulingNumber || '',
                    rulingResult: selectedRuling.rulingResult || '',
                    rulingType: selectedRuling.rulingType || '',
                    appraisalFeeStatus: selectedRuling.appraisalFeeStatus || '',
                    acceptedAppraisalFee: selectedRuling.acceptedAppraisalFee?.toString() || '',
                    powerOfAttorneyFee: selectedRuling.powerOfAttorneyFee?.toString() || '',
                    actionForRuling: selectedRuling.actionForRuling || '',
                    objectionFee: selectedRuling.objectionFee?.toString() || '',
                    objectionCaseNumber: selectedRuling.objectionCaseNumber || '',
                    objectingParty: selectedRuling.objectingParty || '',
                    opposingPowerOfAttorneyFee: selectedRuling.opposingPowerOfAttorneyFee?.toString() || '',
                    willPayCounterPowerOfAttorneyFee: selectedRuling.willPayCounterPowerOfAttorneyFee || false,
                    cpFullName: selectedRuling.cpFullName || '',
                    cpIban: selectedRuling.cpIban || '',
                    cpBank: selectedRuling.cpBank || '',
                    cpEmail: selectedRuling.cpEmail || '',
                    comments: commentText
                });
            }
            setValidationErrors({});
        }
    }, [isOpen, mode, selectedRuling, arbitrationId]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;

        if (type === 'checkbox') {
            setRulingData(prev => ({ ...prev, [name]: checked }));
        } else if (name === 'acceptedAppraisalFee' || name === 'powerOfAttorneyFee' ||
            name === 'objectionFee' || name === 'opposingPowerOfAttorneyFee') {
            // Para alanları için InterlocutoryRulingDataModal'daki mantığı uygula
            let processedValue = value.replace(/[^0-9.,]/g, '');
            processedValue = processedValue.replace(',', '.');
            const decimalCheck = processedValue.split('.');
            if (decimalCheck.length > 2) {
                processedValue = decimalCheck[0] + '.' + decimalCheck.slice(1).join('');
            }
            if (decimalCheck[1] && decimalCheck[1].length > 2) {
                processedValue = decimalCheck[0] + '.' + decimalCheck[1].slice(0, 2);
            }
            setRulingData(prev => ({ ...prev, [name]: processedValue }));
        } else {
            setRulingData(prev => ({
                ...prev,
                [name]: value
            }));
        }

        // Clear validation error when user starts typing
        if (validationErrors[name]) {
            setValidationErrors(prev => ({
                ...prev,
                [name]: null
            }));
        }
    };

    const validateForm = () => {
        const errors = {};

        if (!rulingData.rulingNumber?.trim()) {
            errors.rulingNumber = 'Karar numarası gereklidir';
        }

        if (!rulingData.arrivalDate) {
            errors.arrivalDate = 'Geliş tarihi gereklidir';
        }

        setValidationErrors(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error('Lütfen zorunlu alanları doldurun.');
            return;
        }

        setIsSubmitting(true);

        try {
            // API'ye gönderilecek veriyi API yapısına uygun şekilde hazırla
            const apiData = {
                ...rulingData,
                arbitration: [arbitrationId], // arbitrationId'yi array olarak gönder
                // Sayısal alanları InterlocutoryRuling'deki mantıkla number'a çevir
                acceptedAppraisalFee: rulingData.acceptedAppraisalFee ? Number(String(rulingData.acceptedAppraisalFee).replace(/,/g, '.')) || 0 : 0,
                powerOfAttorneyFee: rulingData.powerOfAttorneyFee ? Number(String(rulingData.powerOfAttorneyFee).replace(/,/g, '.')) || 0 : 0,
                objectionFee: rulingData.objectionFee ? Number(String(rulingData.objectionFee).replace(/,/g, '.')) || 0 : 0,
                opposingPowerOfAttorneyFee: rulingData.opposingPowerOfAttorneyFee ? Number(String(rulingData.opposingPowerOfAttorneyFee).replace(/,/g, '.')) || 0 : 0,
                // Karşı taraf bilgileri
                cpFullName: rulingData.cpFullName || null,
                cpIban: rulingData.cpIban || null,
                cpBank: rulingData.cpBank || null,
                cpEmail: rulingData.cpEmail || null,
                // Comments'i API'nin beklediği formata çevir
                comments: rulingData.comments ? [{ comment: rulingData.comments }] : [],
                // Boş arrays
                objectionExpenses: [],
                counterPartyPoaExpenses: []
            };

            console.log('RulingDataModal: API Data being sent:', apiData);

            await handleAddModifyOperation({
                apiEndpoint,
                selectedItem: mode === 'modify' ? selectedRuling : null,
                mode,
                data: apiData,
                refreshDataCallback: refreshData,
                componentName: 'Karar'
            });

            toggle();
            refreshData();
        } catch (error) {
            console.error('RulingDataModal: Submit error:', error);
            toast.error('Bir hata oluştu. Lütfen tekrar deneyin.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} size="xl">
            <ModalHeader toggle={toggle}>
                {mode === 'add' ? 'Karar Ekle' : 'Karar Düzenle'}
            </ModalHeader>
            <Form onSubmit={handleSubmit}>
                <ModalBody>
                    {Object.keys(validationErrors).length > 0 && (
                        <Alert color="danger">
                            <ul className="mb-0">
                                {Object.values(validationErrors).map((error, index) => (
                                    <li key={index}>{error}</li>
                                ))}
                            </ul>
                        </Alert>
                    )}

                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label for="arrivalDate">
                                    Geliş Tarihi <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="date"
                                    name="arrivalDate"
                                    id="arrivalDate"
                                    value={rulingData.arrivalDate}
                                    onChange={handleInputChange}
                                    invalid={!!validationErrors.arrivalDate}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label for="rulingNumber">
                                    Karar Numarası <span className="text-danger">*</span>
                                </Label>
                                <Input
                                    type="text"
                                    name="rulingNumber"
                                    id="rulingNumber"
                                    value={rulingData.rulingNumber}
                                    onChange={handleInputChange}
                                    placeholder="Karar numarasını giriniz"
                                    invalid={!!validationErrors.rulingNumber}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label for="rulingResult">Karar Sonucu</Label>
                                <Input
                                    type="select"
                                    name="rulingResult"
                                    id="rulingResult"
                                    value={rulingData.rulingResult}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Karar sonucu seçiniz</option>
                                    <option value="Kabul">Kabul</option>
                                    <option value="Kısmi Kabul">Kısmi Kabul</option>
                                    <option value="KVYO">KVYO</option>
                                    <option value="Ret">Ret</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>

                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label for="rulingType">Karar Türü</Label>
                                <Input
                                    type="select"
                                    name="rulingType"
                                    id="rulingType"
                                    value={rulingData.rulingType}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Karar türü seçiniz</option>
                                    <option value="Normal">Normal</option>
                                    <option value="Tavzih">Tavzih</option>
                                    <option value="Tashih">Tashih</option>
                                    <option value="İtiraz">İtiraz</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label for="appraisalFeeStatus">Ekspertiz Ücreti Durumu</Label>
                                <Input
                                    type="select"
                                    name="appraisalFeeStatus"
                                    id="appraisalFeeStatus"
                                    value={rulingData.appraisalFeeStatus}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Durum seçiniz</option>
                                    <option value="Kabul">Kabul</option>
                                    <option value="Ret">Ret</option>
                                    <option value="Kısmi Kabul">Kısmi Kabul</option>
                                    <option value="Karara Yapılacak İşlem">Karara Yapılacak İşlem</option>
                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label for="actionForRuling">Karar İçin Eylem</Label>
                                <Input
                                    type="select"
                                    name="actionForRuling"
                                    id="actionForRuling"
                                    value={rulingData.actionForRuling}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Eylem seçiniz</option>
                                    <option value="Uygun">Uygun</option>
                                    <option value="İtiraz">İtiraz</option>
                                    <option value="Tavzih">Tavzih</option>
                                    <option value="Tashih">Tashih</option>
                                    <option value="Temyiz">Temyiz</option>
                                </Input>
                            </FormGroup>
                        </Col>
                    </Row>
                    {/* İtiraz alanları - sadece karar türü "İtiraz" seçildiğinde göster */}
                    {rulingData.rulingType === 'İtiraz' && (
                        <Row>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="objectionFee">İtiraz Ücreti</Label>
                                    <InputGroup>
                                        <Input
                                            type="text"
                                            name="objectionFee"
                                            id="objectionFee"
                                            value={rulingData.objectionFee}
                                            onChange={handleInputChange}
                                            placeholder="Örn: 5000.75"
                                            style={{
                                                textAlign: 'right',
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0
                                            }}
                                        />
                                        <InputGroupText
                                            style={{
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                                backgroundColor: '#f8f9fa',
                                                borderLeft: 'none'
                                            }}
                                        >
                                            ₺
                                        </InputGroupText>
                                    </InputGroup>
                                    <small className="text-muted">Ondalık ayırıcı olarak nokta (.) kullanınız</small>
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="objectionCaseNumber">İtiraz Dava Numarası</Label>
                                    <Input
                                        type="text"
                                        name="objectionCaseNumber"
                                        id="objectionCaseNumber"
                                        value={rulingData.objectionCaseNumber}
                                        onChange={handleInputChange}
                                        placeholder="İtiraz dava numarasını giriniz"
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="4">
                                <FormGroup>
                                    <Label for="objectingParty">İtiraz Eden Taraf</Label>
                                    <Input
                                        type="select"
                                        name="objectingParty"
                                        id="objectingParty"
                                        value={rulingData.objectingParty}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">İtiraz eden tarafı seçiniz</option>
                                        <option value="Sigorta Şirketi">Sigorta Şirketi</option>
                                        <option value="Biz">Biz</option>
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label for="acceptedAppraisalFee">Kabul Edilen Ekspertiz Ücreti</Label>
                                <InputGroup>
                                    <Input
                                        type="text"
                                        name="acceptedAppraisalFee"
                                        id="acceptedAppraisalFee"
                                        value={rulingData.acceptedAppraisalFee}
                                        onChange={handleInputChange}
                                        placeholder="Örn: 5000.75"
                                        style={{
                                            textAlign: 'right',
                                            borderTopRightRadius: 0,
                                            borderBottomRightRadius: 0
                                        }}
                                    />
                                    <InputGroupText
                                        style={{
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            backgroundColor: '#f8f9fa',
                                            borderLeft: 'none'
                                        }}
                                    >
                                        ₺
                                    </InputGroupText>
                                </InputGroup>
                                <small className="text-muted">Ondalık ayırıcı olarak nokta (.) kullanınız</small>
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <Label for="powerOfAttorneyFee">Vekalet Ücreti</Label>
                                <InputGroup>
                                    <Input
                                        type="text"
                                        name="powerOfAttorneyFee"
                                        id="powerOfAttorneyFee"
                                        value={rulingData.powerOfAttorneyFee}
                                        onChange={handleInputChange}
                                        placeholder="Örn: 5000.75"
                                        style={{
                                            textAlign: 'right',
                                            borderTopRightRadius: 0,
                                            borderBottomRightRadius: 0
                                        }}
                                    />
                                    <InputGroupText
                                        style={{
                                            borderTopLeftRadius: 0,
                                            borderBottomLeftRadius: 0,
                                            backgroundColor: '#f8f9fa',
                                            borderLeft: 'none'
                                        }}
                                    >
                                        ₺
                                    </InputGroupText>
                                </InputGroup>
                                <small className="text-muted">Ondalık ayırıcı olarak nokta (.) kullanınız</small>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup className="mb-3">
                                <Label className="text-nowrap mb-2">Karşı Vekalet Ücreti Ödenecek mi?</Label>
                                <div className="d-flex mt-2">
                                    <div className="radio radio-primary me-3 d-flex align-items-center">
                                        <Input
                                            name="willPayCounterPowerOfAttorneyFee"
                                            type="radio"
                                            value="true"
                                            id="willPayYes"
                                            checked={rulingData.willPayCounterPowerOfAttorneyFee === true}
                                            onChange={(e) => setRulingData(prev => ({ ...prev, willPayCounterPowerOfAttorneyFee: e.target.value === 'true' }))}
                                        />
                                        <Label check for="willPayYes" className="ms-1 mb-0">Evet</Label>
                                    </div>
                                    <div className="radio radio-primary d-flex align-items-center">
                                        <Input
                                            name="willPayCounterPowerOfAttorneyFee"
                                            type="radio"
                                            value="false"
                                            id="willPayNo"
                                            checked={rulingData.willPayCounterPowerOfAttorneyFee === false}
                                            onChange={(e) => setRulingData(prev => ({ ...prev, willPayCounterPowerOfAttorneyFee: e.target.value === 'true' }))}
                                        />
                                        <Label check for="willPayNo" className="ms-1 mb-0">Hayır</Label>
                                    </div>
                                </div>
                            </FormGroup>
                        </Col>
                        {/* Karşı Vekalet Ücreti alanı - sadece "Evet" seçildiğinde göster */}
                        {rulingData.willPayCounterPowerOfAttorneyFee === true && (
                            <Col md="6">
                                <FormGroup>
                                    <Label for="opposingPowerOfAttorneyFee">Karşı Vekalet Ücreti</Label>
                                    <InputGroup>
                                        <Input
                                            type="text"
                                            name="opposingPowerOfAttorneyFee"
                                            id="opposingPowerOfAttorneyFee"
                                            value={rulingData.opposingPowerOfAttorneyFee}
                                            onChange={handleInputChange}
                                            placeholder="Örn: 5000.75"
                                            style={{
                                                textAlign: 'right',
                                                borderTopRightRadius: 0,
                                                borderBottomRightRadius: 0
                                            }}
                                        />
                                        <InputGroupText
                                            style={{
                                                borderTopLeftRadius: 0,
                                                borderBottomLeftRadius: 0,
                                                backgroundColor: '#f8f9fa',
                                                borderLeft: 'none'
                                            }}
                                        >
                                            ₺
                                        </InputGroupText>
                                    </InputGroup>
                                    <small className="text-muted">Ondalık ayırıcı olarak nokta (.) kullanınız</small>
                                </FormGroup>
                            </Col>
                        )}
                    </Row>

                    {/* Karşı Taraf Bilgileri - sadece "Karşı Vekalet Ücreti Ödenecek" seçili ise göster */}
                    {rulingData.willPayCounterPowerOfAttorneyFee === true && (
                        <>
                            <Row>
                                <Col md="12">
                                    <h6 className="mb-3 text-primary">Karşı Taraf Bilgileri</h6>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label for="cpFullName">Karşı Taraf Ad Soyad</Label>
                                        <Input
                                            type="text"
                                            name="cpFullName"
                                            id="cpFullName"
                                            value={rulingData.cpFullName}
                                            onChange={handleInputChange}
                                            placeholder="Ad soyad giriniz"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label for="cpEmail">Karşı Taraf E-posta</Label>
                                        <Input
                                            type="email"
                                            name="cpEmail"
                                            id="cpEmail"
                                            value={rulingData.cpEmail}
                                            onChange={handleInputChange}
                                            placeholder="ornek@email.com"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label for="cpBank">Karşı Taraf Banka</Label>
                                        <Input
                                            type="text"
                                            name="cpBank"
                                            id="cpBank"
                                            value={rulingData.cpBank}
                                            onChange={handleInputChange}
                                            placeholder="Banka adı giriniz"
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label for="cpIban">Karşı Taraf IBAN</Label>
                                        <Input
                                            type="text"
                                            name="cpIban"
                                            id="cpIban"
                                            value={rulingData.cpIban}
                                            onChange={handleInputChange}
                                            placeholder="TR00 0000 0000 0000 0000 0000 00"
                                            maxLength="34"
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                        </>
                    )}
                    <Row>
                        <Col md="12">
                            <FormGroup>
                                <Label for="comments">Yorum</Label>
                                <Input
                                    type="textarea"
                                    name="comments"
                                    id="comments"
                                    rows="3"
                                    value={rulingData.comments}
                                    onChange={handleInputChange}
                                    placeholder="Karar ile ilgili yorumlarınızı giriniz..."
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        color="secondary"
                        onClick={toggle}
                        disabled={isSubmitting}
                    >
                        İptal
                    </Button>
                    <Button
                        color="primary"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Kaydediliyor...' : (mode === 'add' ? 'Ekle' : 'Güncelle')}
                    </Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

export default RulingDataModal;
